export default __webpack_public_path__ + "static/media/trash-icon-white.929a7c1c.svg";